import { createFileRoute } from '@tanstack/react-router';
import AuthComponent from '@shared/pages/authenticationPage/authComponent';

// Define the search param type for this route using TypeScript only
export type AuthRouteSearch = { redirect?: string };

export const Route = createFileRoute('/auth')({
  component: AuthComponent,
});
